import localeCodes from "locale-codes";

/**
 * Returns true if the tag is a real BCP 47 locale known to the locale-codes
 * registry (e.g. "el", "en", "fr", "pt-BR").
 *
 * Unlike `looksLikeLocale`, this validates against actual locale data rather
 * than just matching the structural pattern — so short partner codes like
 * "du", "sfr", or "olu" correctly return false.
 */
export function isKnownLocaleTag(tag: string): boolean {
	return localeCodes.getByTag(tag) !== undefined;
}
